var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"28","viewBox":"0 0 24 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"24","height":"14.9189","fill":"#22539e"}}),_c('rect',{attrs:{"y":"11.6756","width":"2.59459","height":"16.2162","fill":"#22539e"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }